import * as React from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { cn } from '../../lib/cn';
import { useFormFieldContext } from '../form_field/form_field';

export interface PasswordInputProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'type'
> {
  error?: boolean;
  labels?: { show_password?: string; hide_password?: string };
}

export const PasswordInput = React.forwardRef<
  HTMLInputElement,
  PasswordInputProps
>(function PasswordInput({ className, error, labels, ...props }, ref) {
  const [visible, setVisible] = React.useState(false);
  const formFieldContext = useFormFieldContext();

  return (
    <div className="relative w-full">
      <input
        ref={ref}
        type={visible ? 'text' : 'password'}
        className={cn('nv-input pe-10', error && 'nv-field-error', className)}
        aria-describedby={formFieldContext?.describedBy}
        aria-invalid={formFieldContext?.ariaInvalid}
        {...props}
      />
      <button
        type="button"
        aria-label={
          visible
            ? (labels?.hide_password ?? 'Hide password')
            : (labels?.show_password ?? 'Show password')
        }
        onClick={() => {
          setVisible((v) => !v);
        }}
        className="absolute end-3 top-1/2 -translate-y-1/2 text-ink-muted hover:text-ink transition-colors"
      >
        {visible ? (
          <EyeOff size={16} strokeWidth={1.75} />
        ) : (
          <Eye size={16} strokeWidth={1.75} />
        )}
      </button>
    </div>
  );
});
